module.exports = "<div class='title text-center'>\r\n  <img src=\"dsa_pruebas/assets/img/logo_municipio.jpg\" alt=\"Logo\" width=\"250\">\r\n</div>"